/* Mstrel mobile helper.

   1. TAG every migrated section with "mstrel-m" (so no .liquid file has to be touched).

   2. FORCE THE SIDE GUTTER on mobile with inline !important styles.
      product-main and dual-layer are the only two sections using the shared .mstrel-wrap class, and
      the theme's mstrel-header.css sets .mstrel-wrap{padding:0 80px}. An inline style with priority
      'important' cannot be beaten by any stylesheet rule, in any load order.

   3. HERO ONLY: restore the previous behaviour. The hero has an old, never-tested
      @media (max-width:767px) block of its own. Until now the global "strip mobile rules" step
      deleted it, so the hero showed the desktop canvas scaled down - which is what it is supposed
      to look like. Turning that global step off made the untested block go live and broke the hero.
      So the strip is applied again, but ONLY to the hero's own <style> block, and the hero is
      zoomed like before. Nothing else on the page has any CSS removed.

   4. ZOOM non-migrated sections down to devicewidth/1440 (currently only the hero). */
(function(){
  var DESIGN=1440, BP=992, GUT=10;   /* <- the one side-gutter number, in px */

  /* sections with a hand-built mobile layout - tagged .mstrel-m, never zoomed */
  var MOBILE=[
    'mstrel-pdp','mstrel-dual','mstrel-mat','mstrel-wash','mstrel-cover','mstrel-cmp','mstrel-wp',
    'mstrel-faq','mstrel-nl','mstrel-reviews',
    'mstrel-support','mstrel-video','mstrel-colors','mstrel-transform','mstrel-sizes','mstrel-products',
    'mstrel-ah','mstrel-ai','mstrel-vm','mstrel-ad','mstrel-sv'
  ];
  /* never tagged, never given a forced gutter */
  var SKIP=['mstrel-announce','mstrel-benefits'];

  var BOXES=['.mstrel-wrap','.mstrel-faq__wrap','.mstrel-colors__wrap','.mstrel-products__wrap',
             '.mstrel-transform__grid','[class$="__canvas"]','[class*="__canvas "]'];

  function markMobile(){
    for(var i=0;i<MOBILE.length;i++){
      var els=document.querySelectorAll('section.'+MOBILE[i]);
      for(var j=0;j<els.length;j++){ els[j].classList.add('mstrel-m'); }
    }
  }

  function sections(){
    var out=[], all=document.querySelectorAll('section[class*="mstrel-"]');
    for(var i=0;i<all.length;i++){
      var s=all[i], skip=false;
      for(var j=0;j<SKIP.length;j++){ if(s.classList.contains(SKIP[j])) skip=true; }
      if(!skip) out.push(s);
    }
    return out;
  }

  /* ---- HERO ONLY: drop its own untested mobile media rules, exactly as before ---- */
  var heroStripped=false;
  function stripHeroMobileRules(){
    if(heroStripped) return; 
    var styles=document.querySelectorAll('style');
    for(var i=0;i<styles.length;i++){
      var st=styles[i];
      if(!st.textContent) continue;
      /* only the hero's own <style> block - identified by a class unique to it */
      if(st.textContent.indexOf('.mstrel-hero__union')<0) continue;
      var sheet=st.sheet; if(!sheet) continue;
      var rules; try{ rules=sheet.cssRules; }catch(e){ continue; }
      for(var j=rules.length-1;j>=0;j--){
        var r=rules[j];
        if(r.type===4 && /max-width\s*:\s*(\d+)px/.test(r.conditionText||(r.media&&r.media.mediaText)||'')){
          if(parseInt(RegExp.$1,10)<BP){ try{ sheet.deleteRule(j); }catch(e){} }
        }
      }
      heroStripped=true;
    }
  }

  function setImp(el,prop,val){ try{ el.style.setProperty(prop,val,'important'); }catch(e){} }
  function clr(el,prop){ try{ el.style.removeProperty(prop); }catch(e){} }
  var PROPS=['padding-left','padding-right','width','max-width','margin-left','margin-right','box-sizing'];

  function gutter(on){
    var secs=sections();
    for(var i=0;i<secs.length;i++){
      var s=secs[i];
      if(s.classList.contains('mstrel-hero')) continue;    /* the hero keeps its own geometry */
      var g = s.classList.contains('mstrel-nl') ? 24 : GUT;
      var boxes=[];
      for(var b=0;b<BOXES.length;b++){
        var found=s.querySelectorAll(BOXES[b]);
        for(var k=0;k<found.length;k++){ if(boxes.indexOf(found[k])<0) boxes.push(found[k]); }
      }
      for(var n=0;n<boxes.length;n++){
        var el=boxes[n];
        if(!on){ for(var p=0;p<PROPS.length;p++) clr(el,PROPS[p]); continue; }
        setImp(el,'box-sizing','border-box');
        setImp(el,'width','100%');
        setImp(el,'max-width','100%');
        setImp(el,'margin-left','0');
        setImp(el,'margin-right','0');
        setImp(el,'padding-left',g+'px');
        setImp(el,'padding-right',g+'px');
      }
    }
    var fill=document.querySelectorAll('.mstrel-pdp__info, .mstrel-pdp__info > *, .mstrel-pdp__form, .mstrel-pdp__form > *, .mstrel-pdp__acc, .mstrel-pdp__atc, .mstrel-dual__head');
    for(var q=0;q<fill.length;q++){
      var e=fill[q];
      if(!on){ clr(e,'width'); clr(e,'max-width'); continue; }
      if(e.classList.contains('mstrel-pdp__qty')){ setImp(e,'width','168px'); setImp(e,'max-width','168px'); continue; }
      setImp(e,'width','100%'); setImp(e,'max-width','100%');
    }
  }

  function fit(){
    markMobile();
    var w=window.innerWidth||document.documentElement.clientWidth;
    var on=w<BP;
    if(on) stripHeroMobileRules();
    gutter(on);
    var z=on?(w/DESIGN).toFixed(4):'';
    var list=sections();
    for(var i=0;i<list.length;i++){ if(!list[i].classList.contains('mstrel-m')) list[i].style.zoom=z; }
    var opted=document.querySelectorAll('section.mstrel-m');
    for(var k=0;k<opted.length;k++){ opted[k].style.zoom=''; }
  }

  markMobile();
  function boot(){ fit(); var t; window.addEventListener('resize',function(){clearTimeout(t);t=setTimeout(fit,120);}); window.addEventListener('orientationchange',function(){setTimeout(fit,200);}); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  window.addEventListener('load',fit);
  setTimeout(fit,600); setTimeout(fit,1800);
})();
